export default __webpack_public_path__ + "static/media/logo.59329201.MP4";